import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, collection, query, where, onSnapshot } from 'firebase/firestore';

function Footer() {
  const location                          = useLocation();
  const currentPath                       = location.pathname;
  const [estPionnier,      setEstPionnier]      = useState(false);
  const [reponsesNonVues,  setReponsesNonVues]  = useState(0);

  useEffect(() => {
    const auth      = getAuth();
    const firestore = getFirestore();
    let unsubReponses = null;

    const unsubAuth = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setEstPionnier(false);
        setReponsesNonVues(0);
        if (unsubReponses) { unsubReponses(); unsubReponses = null; }
        return;
      }

      // ── Infos utilisateur ───────────────────────────────────────────────
      try {
        const snap = await getDoc(doc(firestore, 'users', user.uid));
        if (snap.exists()) setEstPionnier(snap.data().estPionnier === true);
      } catch { setEstPionnier(false); }

      // ── Compteur réponses non vues en temps réel ────────────────────────
      try {
        const q = query(
          collection(firestore, 'messages_contact'),
          where('userId',       '==', user.uid),
          where('reponseAdmin', '!=', null),
          where('reponseVue',   '==', false)
        );
        unsubReponses = onSnapshot(q, (snap) => setReponsesNonVues(snap.size));
      } catch (e) {
        console.warn("Compteur réponses:", e);
        setReponsesNonVues(0);
      }
    });

    return () => {
      unsubAuth();
      if (unsubReponses) unsubReponses();
    };
  }, []);

  const linkStyle = (path) => ({
    color:          currentPath === path ? '#07a993' : '#555',
    fontWeight:     currentPath === path ? 700 : 500,
    textDecoration: 'none',
    padding:        '8px 4px',
    display:        'inline-flex',
    alignItems:     'center',
    gap:            '4px',
    fontSize:       '0.85rem',
  });

  return (
    <footer style={{
      background:    '#f8f9fa',
      borderTop:     '1px solid #dee2e6',
      paddingTop:    '16px',
      paddingBottom: '16px',
      marginTop:     'auto',
    }}>

      {/* ── Liens navigation ──────────────────────────────────────────────── */}
      <div style={{
        display:        'flex',
        flexWrap:       'wrap',
        justifyContent: 'center',
        alignItems:     'center',
        gap:            '4px 16px',
        padding:        '0 16px',
        marginBottom:   '10px',
      }}>

        {/* Contact + badge réponses non vues */}
        <Link to="/contact" style={linkStyle('/contact')}>
          Contact
          {reponsesNonVues > 0 && (
            <span style={{
              fontSize:     '0.6rem',
              background:   '#07a993',
              color:        '#fff',
              padding:      '2px 6px',
              borderRadius: '10px',
              fontWeight:   700,
              lineHeight:   1,
            }}>
              {reponsesNonVues} réponse{reponsesNonVues > 1 ? 's' : ''}
            </span>
          )}
        </Link>

        {/* guide d'installation mobile */}
        <Link to="/guide" style={linkStyle('/guide')}>
        Guide d'installation mobile</Link>

        <Link to="/charte-moderation" style={linkStyle('/charte-moderation')}>
          Charte de modération
        </Link>

        {estPionnier && (
          <Link to="/suggestions"
            style={{ ...linkStyle('/suggestions'), color: '#07a993', fontWeight: 700 }}
            title="Espace pionniers">
            💡 Suggestions
          </Link>
        )}

        <Link to="/cgu" style={linkStyle('/cgu')}>CGU</Link>
        <Link to="/cgv" style={linkStyle('/cgv')}>CGV</Link>
      </div>

      {/* ── Copyright ─────────────────────────────────────────────────────── */}
      <div style={{ textAlign: 'center', fontSize: '0.78rem', color: '#999', padding: '0 16px' }}>
        FredRc 2024 © All Rights Reserved
      </div>

    </footer>
  );
}

export default Footer;